import { CdkConnectedOverlay } from '@angular/cdk/overlay';
import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSelect } from '@angular/material/select';
import { ActivatedRoute, NavigationEnd, Router, RoutesRecognized } from '@angular/router';
import { delay, filter, Observable, of, Subscription } from 'rxjs';
import { AlertWithTimediff } from 'src/app/models/Alert';
import { AlertsService } from 'src/app/services/alerts.service';
import { AuthService } from 'src/app/services/auth.service';
import { EnergyUnits, EnergyUnitService } from 'src/app/services/energy-unit.service';
import { LanguageService } from 'src/app/services/language.service';
import { TicketDialogComponent } from './ticket-dialog/ticket-dialog.component';
import { BreadcrumbService } from 'src/app/services/breadcrumb.service';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, OnDestroy {  

    @ViewChild(MatSelect) matSelectComponent?: MatSelect;
    @ViewChild('userMenu') userMenu?: ElementRef;
    @ViewChild('notificationMenu') notificationMenu?: ElementRef;

    private static readonly MAX_NOTIFICATIONS = 100;

    subscriptions: Subscription[] = []
    notificationAlerts: AlertWithTimediff[] = []
    
    protected newNotificationsFlag = false;

    selectedLanguageObject: any;
    breadCrumbTitle: string[] = [];

    readonly energyUnits = EnergyUnits.ALL;

    constructor(
        protected _languageService: LanguageService,
        protected _authService: AuthService,
        protected _alertsService: AlertsService,
        private _router: Router,
        private _activatedRoute: ActivatedRoute,
        private _dialog: MatDialog,
        private _breadcrumbService: BreadcrumbService,
        protected _energyUnitService: EnergyUnitService
    ) {
        this.selectedLanguageObject = _languageService.getLanguageObject();

        let languageSubscription = this._languageService.selectedLanguage$.subscribe( (newLanguage: string) => {
            this.selectedLanguageObject = _languageService.getLanguageObject();
        })

        this.subscriptions.push(languageSubscription);

        this.subscriptions.push(_alertsService.allUserAlerts$.subscribe( (alerts: AlertWithTimediff[]) => {
            let notificationAlerts = alerts.filter( (alert) => alert.notification == true );

            if (notificationAlerts.length > 0) {
                this.newNotificationsFlag = true;
                notificationAlerts.forEach( (alert) => alert.notification = false );
                this.notificationAlerts.push(...notificationAlerts);

                if (this.notificationAlerts.length > HeaderComponent.MAX_NOTIFICATIONS) {
                    this.notificationAlerts = this.notificationAlerts.slice(-HeaderComponent.MAX_NOTIFICATIONS);
                }
            }
        }));

        this.subscriptions.push(this._breadcrumbService.breadCrumbChangeEvent.subscribe( (breadCrumbTitle: string[]) => {
            this.breadCrumbTitle = breadCrumbTitle;
        }));
    }

    // Subscribed while the user menu is open; a new one was added on every open before
    private _backdropClickSubscription?: Subscription;

    ngOnInit(): void {
    }

    triggerMenu(): void {
        
    }

    /**
     */
    matSelectMenuHandler(isOpen: boolean) {
        this._backdropClickSubscription?.unsubscribe();
        this._backdropClickSubscription = undefined;

        if (isOpen) {
            this._backdropClickSubscription = ((this.matSelectComponent as any)?._overlayDir as CdkConnectedOverlay).backdropClick.subscribe( (event: MouseEvent) => {
                if (this.userMenu != null) {
                    let boundingRectangle = this.userMenu.nativeElement.getBoundingClientRect();
                    let divX = { start: boundingRectangle.left, end: boundingRectangle.right }
                    let divY = { start: boundingRectangle.top, end: boundingRectangle.bottom }
                    
                    if ( divX.start < event.clientX && event.clientX < divX.end && divY.start < event.clientY && event.clientY < divY.end) {
                        event.stopPropagation();
                    }
                }
            });
        }
    }

    notificationClickHandler() {
        this.newNotificationsFlag = false;
        this.notificationAlerts.forEach( (alert: AlertWithTimediff) => {
            alert.isRead = true;
            alert.calculateDateTimeDiff();
        });

    }

    openTicketDialog() {
        this._dialog.open( TicketDialogComponent, { maxWidth: "600px" } )
            .afterClosed()
            .subscribe(
                (selectedOption: string) => {
                    switch (selectedOption) {
                        case 'contract':
                            this._router.navigate(['support-requests']); break;
                        case 'proposal':
                            this._router.navigate(['']); break;
                    }
                }
            );
    }

    signOut() {
        this._authService.signout()
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach((sub: Subscription) => {
            sub.unsubscribe();
        })
        this._backdropClickSubscription?.unsubscribe();
    }
}
